/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import BadgesFeature from './../lib/@waca/vis-badges/src/js/BadgesFeature';
import ChartInsights from './../features/insights/ChartInsights';
import CrosshairsFeature from './../lib/@waca/vis-crosshairs/src/js/CrosshairsFeature';
import SummarizerFeature from './../lib/@waca/vis-summarizer/src/js/SummarizerFeature';
import ImageCaptureFeature from './../lib/@waca/vis-image-capture/src/js/VisImageCaptureFeature';
import VisTitleFetcherFeature from './../lib/@waca/vis-title-fetcher/src/js/VisTitleFetcherFeature';
import ExploreLayoutPropertiesProvider from './../features/properties/ExploreLayoutPropertiesProvider';
import ShowByAction from './../features/showByCompareBy/ShowByAction';
import ShowByView from './../features/showByCompareBy/ShowByView';

export {
	BadgesFeature,
	ChartInsights,
	CrosshairsFeature,
	SummarizerFeature,
	ImageCaptureFeature,
	VisTitleFetcherFeature,
	ExploreLayoutPropertiesProvider,
	ShowByAction,
	ShowByView
};



// WEBPACK FOOTER //
// ./src/js/entrypoints/dashboard-extensions.js